import { useTranslation } from 'react-i18next'
import { type LineChartProps } from '@node-space/ui-components'
import { RewardsDataPoint } from '../types'
import { calculateChartTicks } from '../utils'

export const useChartProps = (
  data: RewardsDataPoint[],
  lineType?: LineChartProps['lineType']
): LineChartProps => {
  const { axisTicks, tickCount } = calculateChartTicks(data.map(d => d.rewards))
  const { t } = useTranslation()

  return {
    data: data.map(d => ({
      ...d,
      rewards: Number.parseFloat(d.rewards.toString()),
    })),
    lineType,
    dataKey: 'rewards',
    labelKey: 'tooltipLabel',
    height: 250,
    yAxisProps: {
      axisTicks,
      axisTickCount: tickCount,
      axisDomain: ['dataMin', 'dataMax'],
    },
    xAxisProps: {
      dataKey: 'tooltipLabel',
      axisTicks: [t('rewards.today'), t('rewards.1Year'), t('rewards.2Years'), t('rewards.3Years')],
    },
  }
}
